// extracted by mini-css-extract-plugin
module.exports = {"container":"PostItem_container__1gWsa","date":"PostItem_date__2LDFZ","title":"PostItem_title__2wBsg"};